import { TileLayer } from 'react-leaflet'

type CustomTileLayerProps = {
  maxZoom?: number
  maxNativeZoom?: number
}

export const CustomTileLayer = ({
  maxZoom = 24,
  maxNativeZoom = 19,
}: CustomTileLayerProps) => {
  const tileLayerAttributes = {
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    className: 'map-tiles',
  }

  return (
    <TileLayer
      {...tileLayerAttributes}
      maxZoom={maxZoom}
      maxNativeZoom={maxNativeZoom}
    />
  )
}
